// 页面样式
import css from 'css/page/gameLibrary.scss'
// 公共方法
import {
  domObserver,
  headerInit,
  memberShip,
} from 'js/common/index'
// 动画
import {
  swiper
} from 'js/animation/index'

/**
 * 绑定 DOM 事件
 */
function bindEvts() {
  memberFormInit()
}

function memberFormInit() {
  memberShip.closeForm.init()
  memberShip.forgetPwdFormInit({
    form: '.yui-memberform0-forgetpwd',
    mask: '.mask-member',
  })
  memberShip.loginFormInit({
    success: () => headerInit(),
    form: '.yui-memberform0-login',
    mask: '.mask-member',
  })
  memberShip.registerFormInit({
    form: '.yui-memberform0-register',
    mask: '.mask-member',
  })
}

/**
 * 滑块初始化
 */
function swipersInit() {
  // 顶部轮播图
  swiper.init({
    selector: '.swiper1',
    options: {
      pagination: {
        bulletActiveClass: 'selected',
        bulletClass: 'dot',
        clickable: true,
        el: '.swiper-pagination-bullets',
      }
    }
  })
}

/**
 * UI 初始化
 */
function uiInit() {
  swipersInit()
}

window._dataBus.get('domReadyObserver').subscribe(() => {
  uiInit()
  bindEvts()
})


// WEBPACK FOOTER //
// ./js/page/gameLibrary.js